import { render } from "./CommunityPage.vue?vue&type=template&id=1bf61920&scoped=true"
import script from "./CommunityPage.vue?vue&type=script&lang=js"
export * from "./CommunityPage.vue?vue&type=script&lang=js"

import "./CommunityPage.vue?vue&type=style&index=0&id=1bf61920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf61920"]])

export default __exports__